import React from 'react'
import Chart from 'react-apexcharts'
import ChartCard from './ChartCard'
import { formatCurrency } from '../mockData'

export default function BudgetVsActualChart({ data }) {
    const options = {
        chart: {
            type: 'bar',
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadius: 4,
                barHeight: '65%',
            },
        },
        xaxis: {
            categories: data.categories,
            labels: {
                style: { colors: '#64748B', fontSize: '12px' },
                formatter: (val) => `R$ ${(val / 1000).toFixed(0)}k`,
            },
        },
        yaxis: {
            labels: {
                style: { colors: '#64748B', fontSize: '12px' },
                maxWidth: 160,
            },
        },
        colors: ['#CBD5E1', '#3B82F6'],
        legend: {
            position: 'top',
            horizontalAlign: 'right',
            labels: { colors: '#64748B' },
        },
        tooltip: {
            theme: 'light',
            y: { formatter: (val) => formatCurrency(val) },
        },
        grid: {
            borderColor: '#E2E8F0',
            strokeDashArray: 4,
        },
        dataLabels: {
            enabled: true,
            formatter: (val, { seriesIndex, dataPointIndex }) => {
                if (seriesIndex === 1) {
                    const orc = data.orcado[dataPointIndex]
                    const real = data.realizado[dataPointIndex]
                    const desvio = (((real - orc) / orc) * 100).toFixed(1)
                    return `${desvio > 0 ? '+' : ''}${desvio}%`
                }
                return ''
            },
            style: { fontSize: '11px', fontWeight: 600 },
            offsetX: 10,
        },
    }

    const series = [
        { name: 'Orçado', data: data.orcado },
        { name: 'Realizado', data: data.realizado },
    ]

    return (
        <ChartCard title="Orçado vs. Realizado" subtitle="Comparativo por categoria de despesa">
            <Chart options={options} series={series} type="bar" height={320} />
        </ChartCard>
    )
}
